<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 500px; overflow-y: hidden;" [ngStyle]="{'height': (this.tabSelected === 1) ? '330px' :  '460px' }" data-cy="case-dialog-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;">
    <div class="section-header" style="flex-basis: 30px;" data-cy="case-header-section">
      <div class="section-header-title" data-cy="case-title-text">
        Add Case
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="case-loading-spinner"></app-tdo-progress-spinner>
    <mat-tab-group *ngIf="!isLoading" dynamicHeight #tabGroup (selectedTabChange)="tabChanged($event)" data-cy="case-tab-group">
      <mat-tab  *ngIf="!isNewchildCase" label="Case For Tooth" value="1" data-cy="case-tooth-tab">
        <div class="section-content" style="flex: 1;" data-cy="case-tooth-content">
          <div style="display: flex; margin-top: 5px;" data-cy="case-tooth-selector-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px;" data-cy="case-tooth-label">Tooth:</div>
            <div style="flex: 1;">
              <tdo-input type="text" [value]="this.selectedTooth.Name" isReadOnly="true" widthString="100%" data-cy="case-tooth-input"></tdo-input>
            </div>
            <div (click)="onOpenToothSelector()" matTooltip="Select Tooth" style="cursor: pointer; color: var(--tdo-secondary);" data-cy="case-tooth-selector-button"><mat-icon>more_horiz</mat-icon></div>
          </div>
          <div style="display: flex; margin-top: 5px;" data-cy="case-procedure-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px;" data-cy="case-procedure-label">For:</div>
            <div style="flex: 1;">
              <tdo-input type="text" [value]="this.selectedCaseProcedure.ProcedureName" isReadOnly="true" widthString="100%" data-cy="case-procedure-input"></tdo-input>
            </div>
            <div (click)="onOpenProcedureSelector()" matTooltip="Select Procedure" style="cursor: pointer; color: var(--tdo-secondary);" data-cy="case-procedure-selector-button"><mat-icon>more_horiz</mat-icon></div>
          </div>
          <div style="display: flex; margin-top: 5px;" data-cy="case-description-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px;" data-cy="case-description-label">Description:</div>
            <div style="flex: 1;">
              <tdo-input type="text" [value]="caseForToothModel.Description" widthString="100%" (inputFinished)="caseForToothModel.Description = $event" data-cy="case-description-input"></tdo-input>
            </div>
          </div>
          <div style="display: flex;" data-cy="case-doctor-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 5px;" data-cy="case-doctor-label">Doctor:</div>
            <div style="flex: 1;">
              <tdo-dropdown-v2 *ngIf="doctors && doctors.length > 0" [datasource]="doctors" [displayPredicate]="doctorPredicate" [value]="getDoctor(caseForToothModel.DoctorId)" (selectionChange)="onDoctorSelectionChange($event)" data-cy="case-doctor-dropdown"></tdo-dropdown-v2>
            </div>
          </div>
          <div style="display: flex;" data-cy="case-referrer-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 5px;" data-cy="case-referrer-label">Referrer:</div>
            <div style="flex: 1;">
              <tdo-dropdown-v2 *ngIf="doctorsRef && doctorsRef.length > 0" [datasource]="doctorsRef" [displayPredicate]="doctorPredicate" [value]="getDoctorRef(caseForToothModel.ReferralDoctorId)" (selectionChange)="onReferringDoctorSelectionChange($event)" data-cy="case-referrer-dropdown"></tdo-dropdown-v2>
            </div>
          </div>
          <div style="display: flex;" data-cy="case-status-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 5px;" data-cy="case-status-label">Status:</div>
            <div style="flex: 1;">
              <app-tdo-enum-select name="enumCaseStatus" [validValueItemId]="caseForToothModel.enumCaseStatusID" (enumSelected)="caseForToothModel.enumCaseStatusID = $event.ValidValueItemId" data-cy="case-status-dropdown"></app-tdo-enum-select>
            </div>
          </div>
          <div style="display: flex; margin-top: 20px;" *ngIf="parentCaseId" data-cy="case-parent-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 5px;" data-cy="case-parent-label">Main Case:</div>
            <div style="flex: 1;">
              <tdo-dropdown-v2 [displayPredicate]="casePredicate" [datasource]="allCases" [value]="getParentCase()" (selectionChange)="onParentCaseChange($event)" data-cy="case-parent-dropdown"></tdo-dropdown-v2>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Blank Case" value="2" data-cy="case-blank-tab">
        <div class="section-content" style="flex: 1;" data-cy="case-blank-content">
          <div style="display: flex;" data-cy="case-blank-description-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 3px;" data-cy="case-blank-description-label">Description:</div>
            <div style="flex: 1;">
              <tdo-input type="text" [value]="model.Case.Description" widthString="100%" (inputFinished)="model.Case.Description = $event" data-cy="case-blank-description-input"></tdo-input>
            </div>
          </div>
          <div style="display: flex;" data-cy="case-blank-referrer-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 3px;" data-cy="case-blank-referrer-label">Referrer:</div>
            <div style="flex: 1;">
              <tdo-dropdown-v2 *ngIf="doctors && doctors.length > 0" [datasource]="doctors" [displayPredicate]="doctorPredicate" [value]="getDoctor(model.Case.ReferringDoctorId)" (selectionChange)="onReferringDoctorSelectionChange($event)" data-cy="case-blank-referrer-dropdown"></tdo-dropdown-v2>
            </div>
          </div>
          <div style="display: flex;" data-cy="case-blank-status-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 3px;" data-cy="case-blank-status-label">Status:</div>
            <div style="flex: 1;">
              <app-tdo-enum-select name="enumCaseStatus" [validValueItemId]="model.Case.enumCaseStatusID" (enumSelected)="model.Case.enumCaseStatusID = $event.ValidValueItemId" data-cy="case-blank-status-dropdown"></app-tdo-enum-select>
            </div>
          </div>
          <div style="display: flex; margin-top: 20px;" *ngIf="parentCaseId" data-cy="case-blank-parent-row">
            <div style="flex-basis: 100px; text-align: right; margin-right: 8px; margin-top: 3px;" data-cy="case-blank-parent-label">Main Case:</div>
            <div style="flex: 1;">
              <tdo-dropdown-v2 [displayPredicate]="casePredicate" [datasource]="allCases" [value]="getParentCase()" (selectionChange)="onParentCaseChange($event)" data-cy="case-blank-parent-dropdown"></tdo-dropdown-v2>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <!--  FOOTER-->
    <div *ngIf="!isLoading" class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="case-footer-section">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="case-cancel-button">Cancel</button>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="case-add-button">Add</button>
    </div>
  </div>
</div>
